import { EventSystem } from '@rss/front-end_ui'
import { config } from '@/config'

const env = config.envFullName
const eventSystem = new EventSystem(env)

export default eventSystem
